import type { ReactNode } from 'react'
import { Inbox } from 'lucide-react'
import { cn } from '@/lib/utils.ts'

export interface EmptyStateProps {
  title?: ReactNode
  /** Alias for title */
  message?: string
  description?: ReactNode
  icon?: ReactNode
  action?: ReactNode
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

/**
 * Standardisierter Leer-Zustand fuer Listen/Tabellen/Tabs.
 * Ersetzt „Keine Daten"-Ad-hoc-Divs.
 */
export function EmptyState({
  title,
  message,
  description,
  icon,
  action,
  className,
  size = 'md',
}: EmptyStateProps) {
  const heading = title ?? message
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center text-gray-600',
        size === 'sm' && 'py-6 gap-2',
        size === 'md' && 'py-10 gap-3',
        size === 'lg' && 'py-16 gap-4',
        className,
      )}
    >
      <div
        className={cn(
          'rounded-full bg-gray-100 text-gray-400 flex items-center justify-center',
          size === 'sm' && 'h-9 w-9 [&>svg]:h-4 [&>svg]:w-4',
          size === 'md' && 'h-12 w-12 [&>svg]:h-5 [&>svg]:w-5',
          size === 'lg' && 'h-16 w-16 [&>svg]:h-7 [&>svg]:w-7',
        )}
      >
        {icon ?? <Inbox />}
      </div>
      <div className="text-body font-medium text-gray-900">{heading}</div>
      {description ? (
        <div className="text-small text-gray-500 max-w-sm">{description}</div>
      ) : null}
      {action ? <div className="mt-1">{action}</div> : null}
    </div>
  )
}
